import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppState } from 'store'
import { programActions } from 'store/slices/programs'
import FacilityFormTemplate from 'templates/FacilityFormTemplate'
import { CLIENT_LIST_LIMIT } from 'utils/client-list-constant'
import EditProgramForm from './components/EditProgramForm'
import ProgramList from './components/ProgramList'
import { useParams } from 'react-router'
import { Location } from 'models/location'
import { useAmplitude } from 'hooks/useAmplitude'
import { AMPLITUDE_EVENTS } from 'amplitude/events'

const ProgramPage = () => {
  const dispatch = useAppDispatch()
  const params: Location = useParams()
  const { currentPage } = useAppState(state => state.programs)
  const [programType, setProgramType] = useState<'edit' | 'create' | null>(null)
  const [programId, setProgramId] = useState<string | null>(null)
  const [searchText, setSearchText] = useState<string>('')
  const [currentProgram, setCurrentProgram] = useState<boolean>(false)
  const { logEvent } = useAmplitude()

  useEffect(() => {
    logEvent(AMPLITUDE_EVENTS.PROGRAMS_PAGE_EVENT, {
      location: params.locationId,
    })
  }, [])

  const getPrograms = async () => {
    await dispatch(
      programActions.getPrograms({
        locationId: params ? params.locationId : '',
        page: currentPage,
        limit: CLIENT_LIST_LIMIT,
        discarded: false,
        visible: !currentProgram,
        search: searchText,
        endDate: currentProgram,
      })
    )
  }
  useEffect(() => {
    (async () => {
      await getPrograms()
    })()
  }, [currentPage, searchText, currentProgram])

  return (
    <FacilityFormTemplate>
      {!programType && (
        <ProgramList
          onEdit={setProgramId}
          onProgramType={setProgramType}
          onSearch={setSearchText}
          onCurrentProgram={setCurrentProgram}
        />
      )}

      {programType && (
        <EditProgramForm
          onBack={async () => {
            await getPrograms()
            setProgramType(null)
          }}
          type={programType}
        />
      )}
    </FacilityFormTemplate>
  )
}

export default ProgramPage
